import * as React from 'react';
import { connect } from 'react-redux';
import IconButton from '../common/IconButton';
import NewToolbarItemScroller from '../common/toolbar-item-scroller/NewToolbarItemScroller';
import { SecondaryToolbarType } from '../header-toolbar/NewHeaderToolbar';
import CurrentToolIcon from '../header-toolbar/CurrentToolIcon';
import { Dispatch, Action } from 'redux';
import UIAction from '../../actions/ui/UIAction';
import { CurrentTool } from '../../reducers/ui/ui';
import { setEnableColoringOfPage, setGeneralRuby }
from '../../actions/PreferenceAction';
import { AppStates } from '../../reducers/app';
import { PreferenceState } from '../../reducers/preference';
import { DialogType } from '../common/SettingDialogContainer';
import ReflowableContentUIAction from '../../actions/ui/ReflowableContentUIAction';
import { SelectedReflowTabType } from '../../drawing/types';
import { isIE11 } from '../../utils/browser';

interface HeaderToolbarReflowableContentLevelProps {
  readonly isVertical: boolean;
  readonly preference: PreferenceState;
  readonly popToTopLevel: () => void;
  readonly setSecondaryToolbarType: (secondaryToolbarType: SecondaryToolbarType) => void;
  readonly setDialogType: (dialogType: DialogType) => void;
  readonly dispatch: Dispatch<Action>;
}

const HeaderToolbarReflowableContentLevel: React.SFC<
  HeaderToolbarReflowableContentLevelProps
> = React.memo((props) => {
  const { isVertical, preference, popToTopLevel, setSecondaryToolbarType, setDialogType,
    dispatch } = props;

  const setSecondaryToolbarTypeToNone = (action?: () => void) => {
    setSecondaryToolbarType(SecondaryToolbarType.None);
    if (action != null) {
      action();
    }
  };

  return <>
    <CurrentToolIcon />

    <NewToolbarItemScroller vertical={isVertical} alignEnd={false} scrollButtons={true}>
      <IconButton
        title="選択"
        imagePath="images/tool-icons/new/select/select"
        rouondRect={true}
        onClick={() => setSecondaryToolbarType(
          SecondaryToolbarType.ReflowableContentSelectionSetting,
        )} />
      <IconButton
        title="ズーム"
        imagePath="images/tool-icons/new/zoom/zoom"
        rouondRect={true}
        onClick={() => setSecondaryToolbarType(
          SecondaryToolbarType.ReflowableContentZoomSetting,
        )} />
      <IconButton
        title="マーカー"
        imagePath="images/tool-icons/new/marker/marker"
        rouondRect={true}
        onClick={() => {
          UIAction.setCurrentTool(CurrentTool.MarkerAppend, dispatch);
          setSecondaryToolbarType(
            SecondaryToolbarType.ReflowableContentMarkerSetting,
          );
        }} />
      <IconButton
        title="消しゴム(マーカー)"
        imagePath="images/tool-icons/new/eraser/eraser"
        rouondRect={true}
        onClick={() => setSecondaryToolbarTypeToNone(() => {
          UIAction.setCurrentTool(CurrentTool.MarkerDelete, dispatch);
        })} />
      <IconButton
        title="白黒反転"
        imagePath="images/tool-icons/new/black_white_flip/black_white_flip"
        rouondRect={true}
        onClick={() => setSecondaryToolbarTypeToNone(() => {
          dispatch(setEnableColoringOfPage(!preference.enableColoringOfPages));
        })} />
      <IconButton
        title="総ルビ"
        imagePath="images/tool-icons/new/ruby/ruby"
        rouondRect={true}
        onClick={() => setSecondaryToolbarTypeToNone(() => {
          dispatch(setGeneralRuby(!preference.enableGeneralRuby));
        })} />
      <IconButton
        title={isIE11() ? '読み上げ機能は、IE11では利用できません。' : '読み上げ'}
        disabled={isIE11()}
        imagePath="images/tool-icons/new/read/read"
        rouondRect={true}
        onClick={() => setSecondaryToolbarType(
          SecondaryToolbarType.TTS,
        )} />
      <IconButton
        title="リフロー設定"
        imagePath="images/tool-icons/new/reflow_setting/reflow_setting"
        rouondRect={true}
        onClick={() => setSecondaryToolbarTypeToNone(() => {
          // 必ずリフロー設定タブから始める
          ReflowableContentUIAction.setSelected(SelectedReflowTabType.Reflow, dispatch);

          setDialogType(DialogType.ReflowableContent);
        })}/>
    </NewToolbarItemScroller>

    <IconButton
      title="戻る"
      imagePath="images/tool-icons/new/btn_top/btn_top"
      rouondRect={true}
      onClick={popToTopLevel} />
  </>;
});

const mapStateToProps = (appStates: AppStates) => ({ preference: appStates.preference });

export default connect(mapStateToProps)(HeaderToolbarReflowableContentLevel);
